<template>
  <div class="sports-bar-wrap" :class="{'sports-bar-wrap-desktop': !$store.state.isMobile}" ref="tabs">
    <div class="sports-bar-scroll " :class="{'ps-2': !$store.state.isMobile}">
      <div
        v-if="$store.state.isMobile"
        class="sports-bar-scroll__item py-2 px-1"
        :class="{'active-sport': $route.name === 'promos'}"
      >
        <div class="d-flex justify-content-center cursor-pointer" @click="$router.push({name: 'promos'})">
          <!-- <div class="sports-bar-scroll__item_icon" :style="{backgroundImage: 'url('+ require('@/assets/sports-bar/award.svg') +')'}"></div> -->
          <div class="sports-bar-scroll__item_icon">
            <svg-icon icon-name="award"/>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div
            class="sports-bar-scroll__item_title fs-8 mt-2 text-uppercase text-center"
            :class="{'active': $route.name === 'promos'}"
          > Promos </div>
        </div>
      </div>
      <!-- <div
        v-if="$store.state.isMobile"
        class="sports-bar-scroll__item py-2 px-1"
        :class="{'active-sport': $route.name === 'blog'}"
      >
        <div class="d-flex justify-content-center cursor-pointer" @click="$router.push({name: 'blog'})">
          <div class="sports-bar-scroll__item_icon">
            <svg-icon icon-name="blog"/>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div
            class="sports-bar-scroll__item_title fs-8 mt-2 text-uppercase text-center"
            :class="{'active': $route.name === 'blog'}"
          > Blog</div>
        </div>
      </div> -->
      
      <div
        class="sports-bar-scroll__item py-2 px-1"
        :class="{'active-sport': 'inplay' === $route.name }"
      >
        <div class="d-flex justify-content-center cursor-pointer position-relative" @click="$router.push({name: 'inplay'})">
          <div class="sports-bar-scroll__item_icon">
            <svg-icon icon-name="inplay"/>
          </div>
          <!-- <div class="tag-new">new</div> -->
          <div v-if="inPlayCounts != null" class="geoff-dot-live dot-live"
            :class="{ 'live-pulse': !!inPlayCounts.inPlay }"
          ></div>
        </div>
        <div class="d-flex justify-content-center">
          <div
            class="sports-bar-scroll__item_title fs-8 mt-2 text-uppercase text-center"
            :class="{'active': 'inplay' === $route.name }"
          >In play</div>
        </div>
      </div>

      <div
        v-for="sport in API.SPORTS"
        :key="sport.title"
        class="sports-bar-scroll__item py-2 px-1"
        :class="{'active-sport': sport.title===$route.params.sportName }"
      >
        <div class="d-flex justify-content-center cursor-pointer position-relative" @click="$router.push({name: 'sport', params:{sportName: sport.title}, query:{}})">
          <!-- <div class="sports-bar-scroll__item_icon" :style="{backgroundImage: 'url('+sport.img+')'}"></div> -->
          <div class="sports-bar-scroll__item_icon" v-html="sport.svg"></div>
          <div v-if="sport?.isNew" class="tag-new">new</div>
        </div>
        <div class="d-flex justify-content-center">
          <div
            class="sports-bar-scroll__item_title fs-8 mt-2 text-uppercase text-center"
            :class="{'active': sport.title===$route.params.sportName}"
          >{{ sport.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SvgIcon from "@/components/UI/SvgIcon";

  export default {
    name: "SportsBar",
    components: {
        SvgIcon
    },
    props: ['currentSportTitle'],
    data: () => {
      return {
        intervalLoad: null,
        inPlayCounts: null
      }
    },
    mounted() {
      if (this.$route.params.sportName){
        let selectedItem = document.getElementsByClassName('active-sport')[0]
        this.$refs.tabs.scrollLeft=selectedItem.offsetLeft - window.visualViewport.width / 2
      }

      // inplay load
      this.intervalLoad = setInterval(()=>this.loadInPlayData(), 5000)
      this.loadInPlayData()
    },
    
    beforeUnmount() {
      if (this.intervalLoad) clearInterval(this.intervalLoad)
    },

    methods: {
      loadInPlayData() {
        this.API.getInplayCount()
          .then(resp => {
            this.inPlayCounts = resp
          })
      }
    }
  }
</script>

<style scoped lang="scss">
.sports-bar-wrap{
  position: absolute;
  left: 0;
  right: 0;
  /* top: calc(3.5rem + env(safe-area-inset-top)); */
  top: 3.5rem;
  height: 4rem;
  background-color: #09080C;
  overflow-y: hidden;
  overflow-x: scroll;
  scroll-behavior: smooth;
  z-index: 100;
}
.sports-bar-wrap-desktop{
  position: fixed;
  top: calc(5rem + env(safe-area-inset-top));
  top: calc(var(--geoff-header-height) + env(safe-area-inset-top));
}
.sports-bar-scroll{
  display: flex;
  align-items: flex-start;
  width: max-content;
}
.sports-bar-scroll__item{
  max-width: 4rem;
  max-height: 3.8rem;
  min-width: 4rem;
}
.sports-bar-scroll__item_icon{
  height: 1.75rem;
  width: 1.75rem;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  color: var(--geoff-sport-bar);
}
.active-sport{
  background-color: rgba(255, 197, 73, 0.46);
  border-radius: 0.3rem;
}
.active-sport .sports-bar-scroll__item_title{
  /*color: rgb(222 189 22 / 78%)!important;*/
}
.active-sport .sports-bar-scroll__item_icon{
  transform: scale(1.15);
  transition: 0.2s;
}
.sports-bar-scroll__item_title{
  color: white;
  line-height: 0.5rem;
}

.tag-new {
    background-color: var(--geoff-accent);
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    position: absolute;
    right: -5px;
    top: -8px;
    padding: 2px 7px;
    text-transform: uppercase;
    border-radius: 50px;
    color: black;
}

.dot-live {
    position: absolute;
    right: 8px;
    top: 0px;
}

</style>